import styled from 'styled-components';

const BaseButton = styled.button`
  cursor: pointer;
  display: flex;
  background: none;
  padding: 0;
  margin: 0;
  border: 0;
`;

export { BaseButton };
